import { useDispatch } from 'react-redux'
import useOrder from '../../modules/order/state/order/use-order'
import useConfig from '../../modules/config/state/use-config'
import { trackBeginCheckoutEvent } from '../../modules/analytics/helpers/track-begin-checkout-event'
import { useEffectOnceWhenReady } from './generalUtilHooks'
import { getCookieValue } from 'modules/utils/getCookieValue'

/**
 * Triggers analytics when the page is loaded and the app is visible.
 *
 * @param isReady - Boolean flag indicating whether the app is visible to the user
 */
const usePageLoadAnalytics = (isReady: boolean) => {
  const config = useConfig()
  const { amount, currency, frequency } = useOrder()
  const dispatch = useDispatch()

  useEffectOnceWhenReady(() => {
    trackBeginCheckoutEvent({
      currency: currency.value ?? 'USD',
      frequency: frequency.value,
      value: Number(amount.value),
      campaignId: config.campaignId,
      campaignName: config.campaignName,
      organizationId: config.organization.id,
      organizationName: config.organization.name,
      designationId: config.designation.designationId,
      dispatch,
    })
  }, [
    isReady, // Only trigger the analytics if the app is visible,
  ])
}

export default usePageLoadAnalytics
